/**
 * AgeStripe — tynn fargestripe på toppen av et beholdnings-kort.
 *
 * Visualiserer "hvor sliten" verifiseringa er:
 *   - aldri talt              → full rød stripe (gjør seg synlig)
 *   - 0% av terskel (i dag)   → tynt grønt strek
 *   - lengre = lengre stripe + varmare farge
 *   - over terskel            → full rød stripe
 *
 * 4px høy, full kort-bredde, ingen tekst — gir et raskt "scanning-blikk"
 * uten å ta vertikal plass eller forstyrre annen layout.
 */
export default function AgeStripe({ item, thresholdDays = 14 }) {
  const last = (item?.last_verified_at || "").trim();
  let ageDays = null;
  if (last) {
    try {
      const d = new Date(last + "T00:00:00Z");
      ageDays = Math.floor((Date.now() - d.getTime()) / 86400000);
    } catch { /* ignore */ }
  }

  // Pct = 0..100 of threshold age. Over threshold capped at 100.
  let pct = 0;
  let bg = "";
  if (ageDays === null) {
    // Never verified — sterk rød hint
    pct = 100;
    bg = "bg-red-400";
  } else if (ageDays <= 0) {
    pct = 5;
    bg = "bg-emerald-400";
  } else if (ageDays >= thresholdDays) {
    pct = 100;
    bg = "bg-red-500";
  } else {
    pct = Math.max(5, Math.round((ageDays / thresholdDays) * 100));
    // Color tier: 0-50% grønn, 50-80% amber, 80-100% rød
    if (pct < 50) bg = "bg-emerald-400";
    else if (pct < 80) bg = "bg-amber-400";
    else bg = "bg-red-500";
  }

  return (
    <div
      className="h-1 w-full bg-stone-100"
      aria-hidden
      data-testid={`age-stripe-${item.id}`}
      title={ageDays === null ? "Aldri talt" : `Talt for ${ageDays} dag(er) siden (terskel: ${thresholdDays}d)`}
    >
      <div
        className={`h-full ${bg} transition-all duration-500`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
